import {ref} from 'vue';
import {requestNPS} from '@/service/common';
import {closeWindow} from '@/bridge';
import {isHigherVersion} from '@/utils/version';
import useUa from './useUa';
import {useDeviceInfo} from './useDeviceInfo';


export const useNPSPopup = () => {
  const {isApp, isXApp} = useUa();
  const {appVersion} = useDeviceInfo();
  const {data: hasPopup} = requestNPS();
  const triggered = ref(false);
  const showNPSPopup = () => {
    let packageName = '';
    if (isXApp.isGaotuApp) {
      packageName = 'superclass';
    }
    else if (isXApp.isJingpinApp) {
      packageName = 'superjingpin';
    }
    else if (isXApp.isTutuApp) {
      packageName = 'supertutu';
    }
    else if (isXApp.isKetangApp) {
      packageName = 'superketang';
    }
    else {
      closeWindow();
      return;
    }
    const scheme = `${packageName}://jump?action_type=open_comment_dialog&commentType=3`;
    location.href = scheme;
  };
  const back = () => {
    if (!isApp) {
      return;
    }
    if (!isHigherVersion(appVersion, '4.71.0')) {
      closeWindow();
      return;
    }
    if (hasPopup.value && !triggered.value) {
      triggered.value = true;
      showNPSPopup();
      return;
    }
    closeWindow();
  };
  return back;
};
